const mdfeTranslate = {
  MDFEEncoding: {
    zh: 'MDFE编码',
    en: 'MDFE encoding',
    pu: 'Número MDFE'
  },
  MDFEKey: {
    zh: 'MDFE秘钥',
    en: 'MDFE key',
    pu: 'Chave MDFE'
  },
  AgreementNumber: {
    zh: '协议编号',
    en: 'Agreement Number',
    pu: 'Número do protocolo'
  },
  startingPoint: {
    zh: '起点',
    en: 'starting point',
    pu: 'Origem'
  },
  destination: {
    zh: '目的地',
    en: 'destination',
    pu: 'Destino'
  },
  LockMDFE: {
    zh: '关闭MDFE',
    en: 'Lock MDFE',
    pu: 'Encerrar MDFE'
  },
  CancelMDFE: {
    zh: '取消MDFE',
    en: 'Cancel MDFE',
    pu: 'Cancelar MDFE'
  },
  ViewPDF: {
    zh: '查看PDF',
    en: 'View PDF',
    pu: 'Visualizar PDF'
  },
  BatchCTEPDF: {
    zh: '批量生成CTE PDF',
    en: 'Batch CTE PDF',
    pu: 'CTE em lote PDF'
  },
  ViewDriver: {
    zh: '查看司机',
    en: 'View Driver',
    pu: 'Ver condutores'
  },
  DownloadXml: {
    zh: '下载xml',
    en: 'Download xml',
    pu: 'Baixar xml'
  },
  DownloadXlsx: {
    zh: '下载xlsx',
    en: 'Download xlsx',
    pu: 'Baixar xlsx'
  },
  ChooseVTag: {
    zh: '选择vTag',
    en: 'Choose vTag',
    pu: 'Selectionar vTag'
  },
  Queue: {
    zh: '队列',
    en: 'Queue',
    pu: 'Fila'
  },
  AddVTagToTheQueue: {
    zh: '添加 vTag 到队列',
    en: 'Add vTag to the queue',
    pu: 'adicionar vTag a fila'
  },
  DeleteAll: {
    zh: '全部删除',
    en: 'Delete all',
    pu: 'Limpar tudo'
  },
  SelectedVTags: {
    zh: '选中的 vTags',
    en: 'Selected vTags',
    pu: 'VTags selecionadas'
  },
  ChooseCompany: {
    zh: '选择公司',
    en: 'Choose company',
    pu: 'Escolha a empresa'
  },
  RouteInformation: {
    zh: '路线信息',
    en: 'Route information',
    pu: 'Informações de trajeto'
  },
  source: {
    zh: '来源',
    en: 'source',
    pu: 'Origem'
  },
  quantity: {
    zh: '数量',
    en: 'quantity',
    pu: 'Quantidade'
  },
  cityCode: {
    zh: '城市代码',
    en: 'City code',
    pu: 'Código do município'
  },
  CityName: {
    zh: '城市名称',
    en: 'City name',
    pu: 'Nome do município'
  },
  RoutePoint: {
    zh: '途径点',
    en: 'Route point',
    pu: 'UFs'
  },
  way: {
    zh: '途径点',
    en: 'Route point',
    pu: 'UF'
  },
  DriverAndVehicle: {
    zh: '司机和车辆',
    en: 'Driver and vehicle',
    pu: 'Motorista e veículo'
  },
  TrailerPlateNumber: {
    zh: '拖车车牌号',
    en: 'Trailer plate number',
    pu: 'Placa do caminhão'
  },
  Next: {
    zh: '下一个',
    en: 'Next',
    pu: 'Próximo'
  },
  Previous: {
    zh: '上一个',
    en: 'Previous',
    pu: 'Anterior'
  },
  VTagsQueue: {
    zh: 'vTag 队列',
    en: 'VTag queue',
    pu: 'Fila de vTag'
  },
  SelectTheVTagType: {
    zh: '选择 vTag 类型',
    en: 'Select the vTag type',
    pu: 'Selecione o tipo de vTag'
  },
  ListOfVTags: {
    zh: 'vTag 列表',
    en: 'List of vTag',
    pu: 'Lista de vTag'
  },
  SelectedVTag: {
    zh: '已选中vTag',
    en: 'Selected vTag',
    pu: 'vTag selecionado'
  },
  QuantityOfPackages: {
    zh: '包裹数量',
    en: 'Quantity of packages',
    pu: 'Quantidade de pacotes'
  },
  FreteTotal: {
    zh: '运费总额',
    en: 'Total freight',
    pu: 'Frete total'
  },
  TotalValue: {
    zh: '总价值',
    en: 'Total value',
    pu: 'Valor total'
  },
  TotalWeight: {
    zh: '总重量',
    en: 'Total weight',
    pu: 'Peso total'
  },
  Packages: {
    zh: '包裹',
    en: 'Packages',
    pu: 'Pacotes'
  },
  PlateNumberDoesNotExist: {
    zh: '车牌号不存在',
    en: 'Plate number does not exist',
    pu: 'Placa não existe'
  },
  PostalCodeFormatIsIncorrect: {
    zh: '邮编格式不正确',
    en: 'Postal code format is incorrect',
    pu: 'Código postal não está correto'
  },
  TheAddressCorrespondingToThePostalCodeDoesNotExist: {
    zh: '邮编对应的地址不存在',
    en: 'The address corresponding to the postal code does not exist',
    pu: 'O endereço correspondente ao código postal não existe'
  },
  OperationFailed: {
    zh: '操作失败',
    en: 'Operation Failed',
    pu: 'Falha na Operação'
  },
  PleaseSelectALabel: {
    zh: '请选择标签',
    en: 'Please select a label',
    pu: 'Selecione uma etiqueta'
  },
  StartingStateInconsistent: {
    zh: '起点州不一致',
    en: 'Starting state inconsistent',
    pu: 'Estado inicial inconsistente'
  },
  DestinationStateInconsistent: {
    zh: '终点州不一致',
    en: 'Destination state inconsistent',
    pu: 'Estado final inconsistente'
  },
  ReasonForCancellation: {
    zh: '取消原因',
    en: 'Reason for cancellation',
    pu: 'Motivo do cancelamento'
  },
  AreYouSureYouWantToCloseTheMDFE: {
    zh: '确定关闭MDFE?',
    en: 'Are you sure you want to close the MDFE?',
    pu: 'Tem certeza de que deseja fechar o MDFE?'
  },
  AreYouSureYouWantToCancel: {
    zh: '确定取消吗?',
    en: 'Are you sure you want to cancel?',
    pu: 'Você tem certeza desse cancelamento?'
  },
  PleaseEnterTheCarSign: {
    zh: '请输入车签号',
    en: 'Please enter the car sign',
    pu: 'Digite o sinal do carro'
  },
  ChooseVehicleAndDriver: {
    zh: '选择车辆和司机',
    en: 'Choose vehicle and driver',
    pu: 'Escolha o veículo e o motorista'
  },
  SelectedDriver: {
    zh: '选定的司机',
    en: 'Selected driver',
    pu: 'Motorista selecionado'
  },
  TrailerRENAVAM: {
    zh: '卡车的车辆国家登记号',
    en: 'Trailer RENAVAM',
    pu: 'RENAVAM do caminhão'
  },
  TrailerTare: {
    zh: '卡车皮重',
    en: 'Trailer tare',
    pu: 'Tara do caminhão'
  },
  TrailerCapacity: {
    zh: '卡车容量',
    en: 'Trailer capacity',
    pu: 'Capacidade do caminhão'
  },
  TrailerRNTRC: {
    zh: '卡车RNTRC',
    en: 'Trailer RNTRC',
    pu: 'RNTRC do caminhão'
  },
  TruckDocuments: {
    zh: '货车证件',
    en: 'Truck documents',
    pu: 'Documento do caminhão'
  },
  TruckPlate: {
    zh: '货车车牌',
    en: 'Truck plate',
    pu: 'Placa do caminhão'
  },
  State: {
    zh: '州',
    en: 'State',
    pu: 'Estado UF'
  },
  WheelKind: {
    zh: '车轮类型',
    en: 'Wheel kind',
    pu: 'Tipo de roda'
  },
  VehicleType: {
    zh: '车辆类型',
    en: 'Vehicle type',
    pu: 'Tipo de carro'
  },
  document: {
    zh: '个人/法人税号',
    en: '',
    pu: 'Documento'
  },
  Proprietário: {
    zh: '车辆所属公司',
    en: '',
    pu: 'Proprietário'
  },
  SelectedDriverCannotBeTheSame: {
    zh: '选择的司机不能相同',
    en: 'Selected driver cannot be the same',
    pu: 'O motorista selecionado não pode ser o mesmo'
  },
  PleaseAddDriverAndVehicle: {
    zh: '请添加司机和车辆',
    en: 'Please add driver and vehicle',
    pu: 'Adicione o motorista e o veículo'
  },
  PlateNumberCannotBeRepeated: {
    zh: '车牌号不能重复',
    en: 'Plate number cannot be repeated',
    pu: 'Placa não pode ser repetida'
  },
  Authorized: {
    zh: '已授权',
    en: 'Authorized',
    pu: 'Autorizado'
  },
  PendingReview: {
    zh: '待审核',
    en: 'Pending Review',
    pu: 'Aguardando Revisão'
  },
  Unprocessed: {
    zh: '未处理',
    en: 'Unprocessed',
    pu: 'Não Processado'
  },
  SelectedVehicles: {
    zh: '已选车辆',
    en: 'Selected Vehicles',
    pu: 'Veículos Selecionados'
  },
  Closed: {
    zh: '已关闭',
    en: 'Closed',
    pu: 'Excluido'
  },
  TotalNumberOfPackages: {
    zh: '包裹总数量',
    en: 'Total number of packages',
    pu: 'Qtd. total de pacotes'
  },
  originalRequestParams: {
    zh: '原始请求参数',
    en: 'Original Request Parameters',
    pu: 'Parâmetros Originais da Requisição'
  },
  responseData: {
    zh: '响应数据',
    en: 'Response Data',
    pu: 'Dados da Resposta'
  },
  CTEExportTemplate: {
    zh: 'CTE导出模板',
    en: 'CTE Export Template',
    pu: 'Modelo de Exportação CTE'
  },
  cteReopen: {
    zh: 'cte补开',
    en: 'cte reopen',
    pu: 'cte reabrir'
  },
  ReopenCteInvoice: {
    zh: '补开cte发票',
    en: 'Reopen cte invoice',
    pu: 'Reabrir a fatura cte'
  },
  BatchCancelInvoice: {
    zh: '批量取消发票',
    en: 'Batch cancel invoice',
    pu: 'Cancelar fatura em lote'
  },
  TaxRateMustBeLessThan1: {
    zh: '税率必须小于1',
    en: 'Tax rate must be less than 1',
    pu: 'Taxa deve ser menor que 1'
  },
  BatchCancelResult: {
    zh: '批量取消结果',
    en: 'Batch cancel result',
    pu: 'Resultado do cancelamento em lote'
  },
  BillingError: {
    zh: '计费错误',
    en: 'Billing Error',
    pu: 'Erro de Cobrança'
  },
  IncorrectRule: {
    zh: '规则有误',
    en: 'Incorrect Rule',
    pu: 'Regra Incorreta'
  },
  CancellationReasonType: {
    zh: '取消原因类型',
    en: 'Cancellation Reason Type',
    pu: 'Tipo de Motivo do Cancelamento'
  },
  PleaseSelectCancellationReasonType: {
    zh: '请选择取消原因类型',
    en: 'Please select cancellation reason type',
    pu: 'Selecione o tipo de motivo do cancelamento'
  },
  PackageNumber: {
    zh: '包裹号',
    en: 'Package Number',
    pu: 'Número da Encomenda'
  },
  InvoiceSecretKey: {
    zh: '发票秘钥',
    en: 'Invoice Secret Key',
    pu: 'Chave Secreta da Fatura'
  },
  ExportByInvoiceKeyOrBusinessOrderNumber: {
    zh: '按发票秘钥或业务单号导出',
    en: 'Export by invoice key or business order number',
    pu: 'Exportar por chave da fatura ou número de ordem de serviço'
  },
  cteKey: {
    zh: 'cte秘钥',
    en: 'cte key',
    pu: 'Chave CTE'
  },
  compartmentDataCleanup: {
    zh: '格口数据清理',
    en: 'Compartment Data Cleanup',
    pu: 'Limpeza de Dados de Compartimento'
  },
  cleanupDataUntilTime: {
    zh: '清理数据截至时间',
    en: 'Cleanup Data Until Time',
    pu: 'Limpar Dados Até o Tempo'
  },
  clickToCleanup: {
    zh: '点击清理',
    en: 'Click to Cleanup',
    pu: 'Clique para Limpar'
  },
  taskProgress: {
    zh: '任务进度',
    en: 'Task Progress',
    pu: 'Progresso da Tarefa'
  },
  totalTasks: {
    zh: '任务总数',
    en: 'Total Tasks',
    pu: 'Total de Tarefas'
  },
  successfulTasks: {
    zh: '成功总数',
    en: 'Successful Tasks',
    pu: 'Tarefas Bem-sucedidas'
  },
  failedTasks: {
    zh: '失败总数',
    en: 'Failed Tasks',
    pu: 'Tarefas Com Falha'
  },
  selectedData: {
    zh: '已选数据',
    en: 'Selected Data',
    pu: 'Dados Selecionados'
  },
  tip0815: {
    zh: '请输入8-14位数字',
    en: 'Selected Data',
    pu: 'Digite de 8 a 14 dígitos'
  },
  tip8Number: {
    zh: '请输入8位纯数字',
    en: '',
    pu: 'Digite 8 dígitos numéricos'
  },
  Coleta: {
    zh: '揽收',
    en: 'Pickup',
    pu: 'Coleta'
  },
  Entrega: {
    zh: '派送',
    en: 'Delivery',
    pu: 'Entrega'
  },
  CarrierSignatureRepeated: {
    zh: '车签号重复',
    en: 'Carrier Signature Repeated',
    pu: 'Carimbo de Carreira Repetido'
  },
  ReopenCTeInvoiceResult: {
    zh: '补开cte发票结果',
    en: 'Reopen CT-e Invoice Result',
    pu: 'Resultado da Reabertura da Fatura CT-e'
  },
  tipPrefix: {
    zh: '如果有多个邮箱，则用英语逗号隔开',
    en: '',
    pu: 'Separe por vírgula se houver várias'
  },
  batchImportEmails: {
    zh: '批量导入对账邮箱',
    en: 'Batch Import Emails',
    pu: 'Importação em Lote de Emails'
  },
  uploadEmailFile: {
    zh: '请上传要导入的邮箱文件',
    en: 'Please upload the email file to import',
    pu: 'Por favor carregue o arquivo de email para importar'
  },
  multipleLineInput: {
    zh: '多个换行输入，单次最多支持10w条',
    en: 'Multiple line input, supports up to 100,000 entries at a time',
    pu: 'Entrada de múltiplas linhas, suporta até 100.000 entradas por vez'
  },
  reconciliationEmail: {
    zh: '对账邮箱',
    en: 'Reconciliation Email',
    pu: 'Email de Reconciliação'
  },
  queryLimitNotice: {
    zh: '单次查询最多10万条，已截取前10万条',
    en: 'Maximum 100,000 records per query, first 100,000 records retrieved',
    pu: 'Máximo de 100.000 registros por consulta, primeiros 100.000 registros recuperados'
  },
  reconciliationEmailTemplate: {
    zh: '对账邮箱模板.csv',
    en: 'Reconciliation Email Template.csv',
    pu: 'Modelo de Email de Reconciliação.csv'
  },
  CTEReopenConfirmation: {
    zh: 'CTE补开确认',
    en: 'CTE Reopen Confirmation',
    pu: 'Confirmação de Reabertura de CTE'
  },
  PleaseConfirmWhetherToReopenTheAboveOrderDataCTE: {
    zh: '请确认是否补开以上订单数据CTE',
    en: 'Please confirm whether to reopen the above order data CTE',
    pu: 'Confirme se deseja reabrir os dados de ordem CTE acima'
  },
  PleaseAgainConfirmWhether: {
    zh: '请二次确认是否补开以上订单数据CTE',
    en: 'Please again confirm whether to reopen the above order data CTE',
    pu: 'Confirme novamente se deseja reabrir os dados de ordem CTE acima'
  },
  CTEBindingBatchNumber: {
    zh: 'CTE绑定批单号',
    en: 'CTE Binding Batch Number',
    pu: 'Número de Lote de Vinculação CTE'
  },
  regularExpress: {
    zh: '普通快递',
    en: 'Regular Express',
    pu: 'Expresso Regular'
  },
  largeParcelExpress: {
    zh: '大件快递',
    en: 'Large Parcel Express',
    pu: 'Expresso de Grande Porte'
  },
  ForceClose: {
    zh: '强制关闭',
    en: 'Force Close',
    pu: 'Fechar Forçado'
  },
  CompanyTaxNumber: {
    zh: '公司税号',
    en: 'Company Tax Number',
    pu: 'Número de Imposto da Empresa'
  },
  EndState: {
    zh: '结束州',
    en: 'End State',
    pu: 'Estado Final'
  },
  EndCity: {
    zh: '结束城市',
    en: 'End City',
    pu: 'Cidade Final'
  },
  AreYouSureYouWantToForceClose: {
    zh: '确定要强制关闭吗？',
    en: 'Are you sure you want to force close?',
    pu: 'Tem certeza de que deseja fechar forçado?'
  },
  OnlyNumbersCanBeEntered: {
    zh: '只能输入数字',
    en: 'Only numbers can be entered',
    pu: 'Só números podem ser inseridos'
  },
  MessageBody: {
    zh: '消息体',
    en: 'Message Body',
    pu: 'Corpo da Mensagem'
  },
  AreYouSureYouWantToRegenerate: {
    zh: '确定重新生成吗？',
    en: 'Are you sure you want to regenerate?',
    pu: 'Tem certeza de que deseja regenerar?'
  },
  GeneratingPDF: {
    zh: '生成PDF中...',
    en: 'Generating PDF...',
    pu: 'Gerando PDF...'
  },
  ProcessingBlock: {
    zh: '处理第',
    en: 'Processing Block',
    pu: 'Processando Bloco'
  },
  Blocks: {
    zh: '块',
    en: '',
    pu: ''
  },
  Preparing: {
    zh: '准备中...',
    en: 'Preparing...',
    pu: 'Preparando...'
  },
  PDFGenerationFailed: {
    zh: 'PDF生成失败',
    en: 'PDF generation failed',
    pu: 'Falha na geração do PDF'
  },
  ConvertingImage: {
    zh: '转换图片中...',
    en: 'Converting image...',
    pu: 'Convertendo imagem...'
  },
  DownloadBaseInvoiceBasicInformation: {
    zh: '下载基票据本信息',
    en: 'Download Base Invoice Basic Information',
    pu: 'Baixar Base Invoice Basic Information'
  },
  DownloadAllInvoiceInformation: {
    zh: '下载票据全部信息',
    en: 'Download Invoice All Information',
    pu: 'Baixar Todas as Informações da Fatura'
  },
  ViewInvoiceBasicInformation: {
    zh: '查看票据基本信息',
    en: 'View Invoice Basic Information',
    pu: 'Ver Informações Básicas da Fatura'
  },
  ViewInvoiceAllInformation: {
    zh: '查看票据全部信息',
    en: 'View Invoice All Information',
    pu: 'Ver Todas as Informações da Fatura'
  },
  ExportNFSeInvoice: {
    zh: '导出NFSe发票',
    en: 'Export NFSe Invoice',
    pu: 'Exportar Fatura NFSe'
  },
  NewCteInvoice: {
    zh: '新开cte发票',
    en: 'New cte Invoice',
    pu: 'Nova Fatura Cte'
  },
  PleaseConfirmWhetherToOpenNewOrderDataCTE: {
    zh: '请确认是否新开以上订单数据CTE',
    en: 'Please confirm whether to open a new order data CTE',
    pu: 'Confirme se deseja abrir os dados de ordem CTE acima'
  },
  PleaseAgainConfirmWhetherToOpenNewOrderDataCTE: {
    zh: '请二次确认是否新开以上订单数据CTE',
    en: 'Please again confirm whether to open a new order data CTE',
    pu: 'Confirme novamente se deseja abrir os dados de ordem CTE acima'
  },
  CTENewConfirmation: {
    zh: 'CTE新开确认',
    en: 'CTE New Confirmation',
    pu: 'Confirmação de Nova CTE'
  },
  UpdateCnpjInformation: {
    zh: '更新cnpj信息',
    en: 'Update cnpj information',
    pu: 'Atualizar informações cnpj'
  },
  GetLatestInformation: {
    zh: '获取最新信息',
    en: 'Get latest information',
    pu: 'Obter informações mais recentes'
  },
  sureUpdateCnpjInformation: {
    zh: '确定要更新cnpj信息吗？',
    en: 'Are you sure you want to update cnpj information?',
    pu: 'Tem certeza de que deseja atualizar as informações cnpj?'
  },
  PleaseEnter12Digits: {
    zh: '请输入12位数字',
    en: 'Please enter 12 digits',
    pu: 'Digite 12 dígitos'
  },
  PleaseSelectBusinessType: {
    zh: '请选择业务类型',
    en: 'Please select business type',
    pu: 'Selecione o tipo de negócio'
  },
  RepeatedWaybillNumber: {
    zh: '重复运单号',
    en: 'Repeated Waybill Number',
    pu: 'Número de Rota Repetido'
  },
  ViewQRCode: {
    zh: '查看二维码',
    en: 'View QR Code',
    pu: 'Ver Código QR'
  },
  MostlyQuery100WaybillNumbers: {
    zh: '最多查询100个车签号',
    en: 'Mostly query 100 waybill numbers',
    pu: 'Mais de 100 números de rota'
  },
  LoadNumber: {
    zh: '装载单号',
    en: 'Load Number',
    pu: 'Número de Carga'
  },
  CargoHandler: {
    zh: '商品货运员',
    en: 'Cargo Handler',
    pu: 'Cargador de Mercadoria'
  },
  InvoiceCode: {
    zh: '商品发票代码',
    en: 'Invoice Code',
    pu: 'Código da Fatura'
  },
  InvoiceAmount: {
    zh: '商品发票金额',
    en: 'Invoice Amount',
    pu: 'Valor da Fatura'
  },
  InvoiceSerialNumber: {
    zh: '商品发票序列号',
    en: 'Invoice Serial Number',
    pu: 'Número de Série da Fatura'
  },
  InvoiceTime: {
    zh: '商品发票时间',
    en: 'Invoice Time',
    pu: 'Data da Fatura'
  },
  LogisticsInvoiceKey: {
    zh: '物流发票秘钥',
    en: 'Logistics invoice key',
    pu: 'Chave da Fatura de Logística'
  },
  LogisticsCargoHandler: {
    zh: '物流货运员',
    en: 'Logistics Cargo Handler',
    pu: 'Cargador de Logística'
  },
  LogisticsInvoiceCode: {
    zh: '物流发票代码',
    en: 'Logistics Invoice Code',
    pu: 'Código da Fatura de Logística'
  },
  LogisticsInvoiceAmount: {
    zh: '物流发票金额',
    en: 'Logistics Invoice Amount',
    pu: 'Valor da Fatura de Logística'
  },
  BuyerTaxNumber: {
    zh: '买家税号',
    en: 'Buyer Tax Number',
    pu: 'Número de Imposto do Comprador'
  },
  BuyerPostalCode: {
    zh: '买家邮政编码',
    en: 'Buyer Postal Code',
    pu: 'Código Postal do Comprador'
  },
  BuyerAddress: {
    zh: '买家地址',
    en: 'Buyer Address',
    pu: 'Endereço do Comprador'
  },
  BuyerDetailedAddress: {
    zh: '买家详细地址',
    en: 'Buyer Detailed Address',
    pu: 'Endereço Detalhado do Comprador'
  },
  BuyerEmail: {
    zh: '买家邮箱',
    en: 'Buyer Email',
    pu: 'Email do Comprador'
  },
  BuyerNameCompanyNameOrPersonalName: {
    zh: '买家名称，公司名或个人名称',
    en: 'Buyer Name, Company Name or Personal Name',
    pu: 'Nome do Comprador, Nome da Empresa ou Nome Pessoal'
  },
  sameHubOperationNotAllowed: {
    zh: '不允许操作同一网点数据',
    en: 'Operation on same hub data not allowed',
    pu: 'Operação nos mesmos dados do centro não permitida'
  },
  YearAndMonth: {
    zh: '年月',
    en: 'Year and month',
    pu: 'Ano e mês'
  },
  OnlyCollect: {
    zh: '仅揽收',
    en: 'Only collect',
    pu: 'Somente coleta'
  },
  OnlySend: {
    zh: '仅派送',
    en: 'Only send',
    pu: 'Somente envio'
  },
  OnlyTotal: {
    zh: '仅总数',
    en: 'Only total',
    pu: 'Somente total'
  },
  TotalNumberDeliveries: {
    zh: '派送数量',
    en: 'Total number of deliveries',
    pu: 'Número total de envios'
  },
  HighestCollectionAmount: {
    zh: '最高揽收量',
    en: 'Highest collection amount',
    pu: 'Maior quantidade de coleta'
  },
  HighestDeliveryAmount: {
    zh: '最高派送量',
    en: 'Highest delivery amount',
    pu: 'Maior quantidade de envio'
  },
  HighestTotal: {
    zh: '最高总量',
    en: 'Highest total',
    pu: 'Maior total'
  },
  AverageDailyTotal: {
    zh: '平均每日总量',
    en: 'Average daily total',
    pu: 'Total médio diário'
  },
  dayAverage: {
    zh: '天平均',
    en: 'Day average',
    pu: 'Média de dia'
  },
  FirstWeek: {
    zh: '第1周',
    en: 'First week',
    pu: 'Primeira Semana'
  },
  SecondWeek: {
    zh: '第2周',
    en: 'Second week',
    pu: 'Segunda Semana'
  },
  ThirdWeek: {
    zh: '第3周',
    en: 'Third week',
    pu: 'Terceira Semana'
  },
  FourthWeek: {
    zh: '第4周',
    en: 'Fourth week',
    pu: 'Quarta Semana'
  },
  FifthWeek: {
    zh: '第5周',
    en: 'Fifth week',
    pu: 'Quinta Semana'
  },
  ClearSelection: {
    zh: '清空勾选',
    en: 'Clear selection',
    pu: 'Limpar seleção'
  },
  FreightAmountTax: {
    zh: '运费金额(含税)',
    en: 'Freight amount (tax included)',
    pu: 'Valor da Frete (incluindo impostos)'
  },
  FreightAmountNoTax: {
    zh: '运费金额(不含税)',
    en: 'Freight amount (tax excluded)',
    pu: 'Valor da Frete (sem impostos)'
  },
  MostlyQuery10Plates: {
    zh: '最多查询10个车牌号',
    en: 'Mostly query 10 plates',
    pu: 'Mais de 10 placas'
  },
  each10PlatesNumber: {
    zh: '多个车牌号换行输入,每次最多查询10个车牌号',
    en: 'Multiple plates number enter a line, each time up to 10 plates number',
    pu: 'Múltiplas placas número de enter uma linha, cada vez até 10 placas número'
  },
  CTEKey: {
    zh: 'CT-e秘钥',
    en: 'CT-e key',
    pu: 'Chave da CT-e'
  },
  VehicleOperationMode: {
    zh: '车辆运营模式',
    en: 'Vehicle operation mode',
    pu: 'Modo de operação do veículo'
  },
  SystemAutomatic: {
    zh: '系统自动',
    en: 'System automatic',
    pu: 'Sistema automático'
  },
  UserManual: {
    zh: '用户手动',
    en: 'User manual',
    pu: 'Manual do usuário'
  },
  OperatorAccount: {
    zh: '操作人账号',
    en: 'Operator account',
    pu: 'Conta do Operador'
  },
  TotalOrderQuantity: {
    zh: '总订单数量',
    en: 'Total order quantity',
    pu: 'Quantidade total de pedidos'
  },
  RepeatOrderNumberQuantity: {
    zh: '重复单号数量',
    en: 'Repeat order number quantity',
    pu: 'Quantidade de números de ordem repetidos'
  },
  RepeatDetails: {
    zh: '重复明细',
    en: 'Repeat details',
    pu: 'Detalhes repetidos'
  },
  RepeatRate: {
    zh: '重复率',
    en: 'Repeat rate',
    pu: 'Taxa de repetição'
  },
  DataExclusion: {
    zh: '数据剔除',
    en: 'Data exclusion',
    pu: 'Exclusão de dados'
  },
  SelectedVTagQueue: {
    zh: '已选择vTag队列',
    en: 'Selected vTag queue',
    pu: 'Fila vTag selecionada'
  },
  PleaseEnterVTagKey: {
    zh: '请输入vTag',
    en: 'Please enter vTag',
    pu: 'Por favor, insira vTag'
  },
  mdfeQueue: {
    zh: 'mdfe队列',
    en: 'mdfe queue',
    pu: 'Fila mdfe'
  },
  PleaseEnterMdfeKey: {
    zh: '请输入mdfe秘钥',
    en: 'Please enter mdfe key',
    pu: 'Por favor, insira a chave mdfe'
  },
  SelectedMdfeQueue: {
    zh: '已选择mdfe队列',
    en: 'Selected mdfe queue',
    pu: 'Fila mdfe selecionada'
  },
  mdfeKeyRepeat: {
    zh: 'mdfe秘钥重复',
    en: 'mdfe key repeat',
    pu: 'Chave mdfe repetida'
  },
  LoadingDataExclusion: {
    zh: '装车重复数据剔除',
    en: 'Loading data exclusion',
    pu: 'Exclusão de dados de carregamento'
  },
  CarrierNumberAssociatedWithNumberPackages: {
    zh: '车签号关联包裹数',
    en: 'Carrier number associated with the number of packages',
    pu: 'Número de pacotes associados ao número de carregamento'
  },
  RepeatPackages: {
    zh: '重复包裹数',
    en: 'Repeat packages quantity',
    pu: 'Quantidade de pacotes repetidos'
  },
  PleaseConfirmAgainWhetherExcludeAboveRepeatOrderNumbers: {
    zh: '请再次确认是否剔除以上重复单号？',
    en: 'Please confirm again whether to exclude the above repeat order numbers?',
    pu: 'Por favor, confirme novamente se deseja excluir os números de ordem repetidos?'
  },
  SelectedVTagQueueCannotBeEmpty: {
    zh: '已选择 vTag 队列不能为空',
    en: 'Selected vTag queue cannot be empty',
    pu: 'A fila vTag selecionada não pode estar vazia'
  },
  SelectedMdfeQueueCannotEmpty: {
    zh: '已选择 mdfe 队列不能为空',
    en: 'Selected mdfe queue cannot be empty',
    pu: 'A fila mdfe selecionada não pode estar vazia'
  },
  NewCteInvoiceResult: {
    zh: '新开cte发票结果',
    en: 'New cte invoice result',
    pu: 'Resultado de nova cte fatura'
  },
  RepeatRateConfiguration: {
    zh: '重复率配置',
    en: 'Repeat rate configuration',
    pu: 'Configuração de taxa de repetição'
  },
  OnlyNumbersBetween0And100Entered: {
    zh: '只能输入0到100的数字',
    en: 'Only numbers between 0 and 100 can be entered',
    pu: 'Apenas números entre 0 e 100 podem ser inseridos'
  },
  CheckDownload: {
    zh: '勾选下载PDF',
    en: 'Check download PDF',
    pu: 'Marque para baixar PDF'
  },
  DownloadByNumber: {
    zh: '按号码下载',
    en: 'Download by number',
    pu: 'Baixar por número'
  },
  downloadExceed2000: {
    zh: '单次下载数据不能超过2000条',
    en: 'Single download data cannot exceed 2000 lines',
    pu: 'Os dados de download não podem exceder 2000 linhas'
  },
  modifyTheRepeatRate: {
    zh: '确定要修改重复率吗？',
    en: 'Are you sure you want to modify the repeat rate?',
    pu: 'Tem certeza de que deseja modificar a taxa de repetição?'
  },
  AbnormalMdfe: {
    zh: '异常mdfe',
    en: 'Abnormal mdfe',
    pu: 'Mdfe anormal'
  },
  AbnormalMdfeProcessing: {
    zh: '异常mdfe处理',
    en: 'Abnormal mdfe processing',
    pu: 'Processamento de mdfe anormal'
  },
  PleaseEnterAbnormalMDFE: {
    zh: '请输入异常MDFE',
    en: 'Please enter an abnormal MDFE',
    pu: 'Por favor, insira um MDFE anormal'
  },
  PleaseConfirmWhetherOperation: {
    zh: '请确认是否执行操作？',
    en: 'Please confirm whether to execute the operation?',
    pu: 'Por favor, confirme se deseja executar a operação?'
  },
  CustomerCode: {
    zh: '客户编码',
    en: 'Customer code',
    pu: 'Código do cliente'
  },
  InvoiceCNPJ: {
    zh: '开票CNPJ',
    en: 'Invoice CNPJ',
    pu: 'CNPJ de fatura'
  },
  InvoiceIE: {
    zh: '开票IE',
    en: 'Invoice IE',
    pu: 'IE de fatura'
  },
  CompanyAbbreviation: {
    zh: '公司简称',
    en: 'Company abbreviation',
    pu: 'Abreviação da empresa'
  },
  CompanyFullName: {
    zh: '公司全称',
    en: 'Company full name',
    pu: 'Nome completo da empresa'
  },
  StateAbbreviationUF: {
    zh: '州缩写UF',
    en: 'State abbreviation UF',
    pu: 'Abreviação do estado UF'
  },
  Street: {
    zh: '街区',
    en: 'Street',
    pu: 'Rua'
  },
  SupplementalAddress: {
    zh: '补充地址',
    en: 'Supplemental address',
    pu: 'Endereço complementar'
  },
  IBGECode: {
    zh: 'IBGE代码',
    en: 'IBGE code',
    pu: 'Código IBGE'
  },
  ValidityPeriod: {
    zh: '有效期',
    en: 'Validity period',
    pu: 'Período de validade'
  },
  StartTimeCannotLessCurrentTime: {
    zh: '起始时间不能小于当前时间',
    en: 'Start time cannot be less than the current time',
    pu: 'A data de início não pode ser menor que a data atual'
  },
  StartTimeCannotGreaterThanEqualEndTime: {
    zh: '起始时间不能大于或等于结束时间',
    en: 'Start time cannot be greater than or equal to the end time',
    pu: 'A data de starting não pode ser maior ou igual à data de finalização'
  },
  RequestParameters: {
    zh: '请求参数',
    en: 'Request parameters',
    pu: 'Parâmetros de solicitação'
  },
  ResponseParameters: {
    zh: '响应参数',
    en: 'Response parameters',
    pu: 'Parâmetros de resposta'
  },
  ChangeField: {
    zh: '变更字段',
    en: 'Change field',
    pu: 'Campo de alteração'
  },
  OldValue: {
    zh: '旧值',
    en: 'Old value',
    pu: 'Valor antigo'
  },
  NewValue: {
    zh: '新值',
    en: 'New value',
    pu: 'Novo valor'
  },
  OneClickFillIn: {
    zh: '一键填入',
    en: 'One click fill in',
    pu: 'Um clique para preencher'
  },
  enter11Digits14: {
    zh: '请输入11位或者14位数字或字母，注意：最后两位必须是数字',
    en: 'Please enter 11 digits or 14 digits number or letter, note: the last two digits must be numbers',
    pu: 'Por favor, insira 11 dígitos ou 14 dígitos número ou letra, nota: os dois últimos dígitos devem ser números'
  },
  SingleMostQuery2000MDFEKey: {
    zh: '单次最多查询2000个MDFE秘钥',
    en: 'Single most query 2000 MDFE key',
    pu: 'Mais de 2000 chaves MDFE'
  },
  BatchNumber: {
    zh: '批次号',
    en: 'Batch number',
    pu: 'Número de lote'
  },
  PleaseEnter9To12Digits: {
    zh: '请输入9到12位数字',
    en: 'Please enter 9 to 12 digits',
    pu: 'Por favor, insira 9 a 12 dígitos'
  },
  PolicyBatchNumber: {
    zh: '保单批号',
    en: 'Policy Batch Number',
    pu: 'Número do Lote da Apólice'
  },
  InProgress: {
    zh: '进行中',
    en: 'In progress',
    pu: 'Em andamento'
  },
  InsuranceCompanyName: {
    zh: '保险公司名称',
    en: 'Insurance company name',
    pu: 'Nome da seguradora'
  },
  InsuranceCompany: {
    zh: '保险公司',
    en: 'Insurance company',
    pu: 'Seguradora'
  },
  AuthenticationInterfaceAddress: {
    zh: '认证接口地址',
    en: 'Authentication interface address',
    pu: 'Endereço da interface de autenticação'
  },
  Expired: {
    zh: '已失效',
    en: 'Expired',
    pu: 'Expirado'
  },
  NotExpired: {
    zh: '未失效',
    en: 'Not expired',
    pu: 'Não expirado'
  },
  PolicyNumber: {
    zh: '保单号',
    en: 'Policy number',
    pu: 'Número da apólice'
  },
  ConfigurationName: {
    zh: '配置名称',
    en: 'Configuration name',
    pu: 'Nome da configuração'
  },
  BatchNumberRequestAddress: {
    zh: '批单号请求地址',
    en: 'Batch number request address',
    pu: 'Endereço da solicitação de número de lote'
  },
  CustomerATMCode: {
    zh: '客户/ATM代码',
    en: 'Customer/ATM code',
    pu: 'Código do cliente/ATM'
  },
  TokenCacheDuration: {
    zh: 'Token缓存时长',
    en: 'Token cache duration',
    pu: 'Duração do cache do token'
  },
  ConfigurationID: {
    zh: '配置ID',
    en: 'Configuration ID',
    pu: 'ID da configuração'
  },
  Pending: {
    zh: '待生效',
    en: 'Pending',
    pu: 'Pendente'
  },
  InEffect: {
    zh: '生效中',
    en: 'In effect',
    pu: 'Em vigor'
  },
  NotEffective: {
    zh: '未生效',
    en: 'Not effective',
    pu: 'Não efetivo'
  },
  PolicyType: {
    zh: '保单类型',
    en: 'Policy type',
    pu: 'Tipo de apólice'
  },
  AdvancedSettings: {
    zh: '高级设置',
    en: 'Advanced settings',
    pu: 'Configurações avançadas'
  },
  ConfigurationInformation: {
    zh: '配置信息',
    en: 'Configuration information',
    pu: 'Informações de configuração'
  },
  Accident: {
    zh: '事故',
    en: 'Accident',
    pu: 'Acidente'
  },
  TheftOfGoods: {
    zh: '货物盗窃',
    en: 'Theft of goods',
    pu: 'Furto de bens'
  },
  NoChineseAllowed: {
    zh: '不允许输入中文',
    en: 'Chinese characters are not allowed',
    pu: 'Não é permitido inserir caracteres chineses'
  },

  inboundTicketCount: {
    zh: '入库票数',
    en: 'Inbound Ticket Count',
    pu: 'Contagem de Tickets de Entrada'
  },
  timelySortingTickets: {
    zh: '及时分拣票数',
    en: 'Timely Sorting Tickets',
    pu: 'Tickets de Triagem Puntual'
  },
  sortingTimelyRate: {
    zh: '分拣及时率',
    en: 'Sorting Timely Rate',
    pu: 'Taxa de Triagem Puntual'
  },
  multipleItemsPerOrder: {
    zh: '一单多件',
    en: 'Multiple Items Per Order',
    pu: 'Múltiplos Itens por Pedido'
  },
  multipleItemsPerOrderSingleNfe: {
    zh: '一单多件(单NFe)',
    en: 'Multiple Items Per Order (Single NFe)',
    pu: 'Múltiplos Itens por Pedido (NFe única)'
  },
  multipleItemsPerOrderMultiNfe: {
    zh: '一单多件(多NFe)',
    en: 'Multiple Items Per Order (Multiple NFes)',
    pu: 'Múltiplos Itens por Pedido (Múltiplas NF-es)'
  },
  mdfeBindingRecord: {
    zh: 'mdfe绑定记录',
    en: 'Mdfe Binding Record',
    pu: 'Registro de Associação Mdfe'
  },
  Serial: {
    zh: '序号',
    en: 'Serial number',
    pu: 'Item'
  },
  StateUF: {
    zh: '州',
    en: 'State',
    pu: 'UF'
  },
  StartZipCode: {
    zh: '开始邮编',
    en: 'Start Zip Code',
    pu: 'Min ZipCode'
  },
  EndZipCode: {
    zh: '结束邮编',
    en: 'End Zip Code',
    pu: 'Max ZipCode'
  },
  NoCorrespondingAddress: {
    zh: '未查询到对应地址信息，请检查CEP是否正确',
    en: 'No corresponding address information was found, please check whether the CEP is correct',
    pu: 'Nenhuma informação de endereço correspondente foi encontrada, verifique se o CEP está correto'
  },
  NoCompanyRegistrationInformation: {
    zh: '未查询到公司注册信息，请检查CNPJ是否正确',
    en: 'No company registration information was found, please check whether the CNPJ is correct',
    pu: 'Nenhuma informação de registro da empresa foi encontrada, verifique se o CNPJ está correto'
  },
  CheckDownloadXML: {
    zh: '勾选下载XML',
    en: 'Check download XML',
    pu: 'Marque para baixar XML'
  },
  TheInputWaybillHasNoAvailableXML: {
    zh: '输入的运单均无可用XML',
    en: 'The input waybill has no available XML',
    pu: 'Nenhum XML disponível para a viagem inserida'
  },
  DownloadPdf: {
    zh: '下载pdf',
    en: 'Download pdf',
    pu: 'Baixar pdf'
  },
  SingleMostDownload10000XML: {
    zh: '单次最多下载10000份XML，超出请分批操作',
    en: 'Single most download 10000 XML, please batch operation if exceeded',
    pu: 'Mais de 10000 XMLs podem ser baixados, por favor, divida a operação'
  },
  ExportSuccessful: {
    zh: '导出成功，共',
    en: 'Export successful,',
    pu: 'Exportado com sucesso,'
  },
  XMLs: {
    zh: '份XML',
    en: 'XMLs',
    pu: 'XMLs'
  },
  ExportedXML: {
    zh: '已导出',
    en: 'Exported',
    pu: 'Exportado'
  },
  NoXMLFound: {
    zh: '份因XML缺失跳过',
    en: 'XMLs skipped because of missing XML',
    pu: 'XMLs pulados por faltar XML'
  },
  inputWaybillNoAvailableXML: {
    zh: '输入的运单均无可用XML',
    en: 'The input waybill has no available XML',
    pu: 'Nenhum XML disponível para a viagem inserida'
  },
  New: {
    zh: '新开',
    en: 'New',
    pu: 'Novo'
  },
  Reopen: {
    zh: '补开',
    en: 'Reopen',
    pu: 'Reabrir'
  },
  CTEInvoiceStatus: {
    zh: 'CTE开票状态',
    en: 'CTE invoice status',
    pu: 'Status da fatura CTE'
  },
  CTEInvoiceKey: {
    zh: 'CTE发票密钥',
    en: 'CTE invoice key',
    pu: 'Chave da fatura CTE'
  },
  CTEInvoiceQuantity: {
    zh: 'CTE开票数量',
    en: 'CTE invoice quantity',
    pu: 'Quantidade da fatura CTE'
  },
  EncerrarMdfeTips: {
    zh: '关闭=结束行程。到达卸货州或信息需变更时使用。必须在对应卸货州操作，未关闭将阻止新MDF-e授权。',
    en: 'Close=End the trip. Use when information needs to be changed or when you arrive at the destination state. Must be done in the destination state; otherwise, new MDF-e authorization will be blocked.',
    pu: 'Encerrar significa finalizar a viagem. Utilize ao chegar ao estado de destino ou quando for necessário alterar informações. O encerramento deve ser feito no estado de destino; caso contrário, não será possível autorizar um novo MDF-e.'
  },
  CancelMdfeTips: {
    zh: '取消=整单作废，不可恢复。仅限授权后24小时内且未启运时可操作。运输已开始则禁止取消。',
    en: 'Cancel=Cancels the entire order, cannot be recovered. Can only be done within 24 hours of authorization and before departure. Cannot be cancelled once the shipment has started.',
    pu: 'Cancela o MDF-e de forma definitiva. Permitido apenas até 24h após a autorização e antes do início da viagem, Após o início da viagem, o cancelamento não é permitido.'
  },
  CloseMDFeEndTheTrip: {
    zh: '关闭 MDF-e（结束行程）',
    en: 'Close MDF-e (End the trip)',
    pu: 'Encerrar MDF-e (Finalizar Viagem)'
  },
  AreYouSureYouWantToCloseThisMDFe: {
    zh: '您确定要关闭此 MDF-e 吗？',
    en: 'Are you sure you want to close this MDF-e?',
    pu: 'Tem certeza de que deseja encerrar este MDF-e?'
  },
  ThisOperationWillEndTheCurrentTrip: {
    zh: '此操作将结束当前行程，且必须在对应的卸货州完成。',
    en: 'This operation will end the current trip, and must be completed in the corresponding unloading state.',
    pu: 'Esta ação encerrará a viagem atual e deve ser realizada no estado de destino.'
  },
  ApplicableScenarios: {
    zh: '适用场景',
    en: 'Applicable scenarios',
    pu: 'Quando utilizar'
  },
  ArrivalAtUnloadingState: {
    zh: '到达卸货州或信息需变更时使用关闭当前行程。',
    en: 'Use to close the current trip when you arrive at the unloading state or when information needs to be changed.',
    pu: 'Utilize ao chegar ao estado de destino ou quando for necessário alterar informações.'
  },
  NecessaryConditions: {
    zh: '必要条件',
    en: 'Necessary conditions',
    pu: 'Condição obrigatória'
  },
  MustBeCompleted: {
    zh: '必须在对应的卸货州（卸货地所在的州）结束。',
    en: 'Must be completed in the corresponding unloading state.',
    pu: 'O encerramento deve ser realizado no estado de destino da carga.'
  },
  UnfinishedEffects: {
    zh: '未结束的影响',
    en: 'Unfinished effects',
    pu: 'Impacto de não encerrar'
  },
  IfNotCompletedCorrespondingUnloadingState: {
    zh: '若未在对应的卸货州结束',
    en: 'If not completed in the corresponding unloading state',
    pu: 'Caso não seja encerrado no estado de destino'
  },
  newMDFeAuthorizationWillBeBlocked: {
    zh: '将阻止新的 MDF-e 授权。',
    en: 'new MDF-e authorization will be blocked.',
    pu: 'não será possível autorizar um novo MDF-e.'
  },
  OperationResult: {
    zh: '操作结果',
    en: 'Operation result',
    pu: 'Resultado'
  },
  AfterClosingYouCanModifyInformation: {
    zh: '关闭后可进行信息变更或重新发起新的 MDF-e。',
    en: 'After closing, you can modify information and re-initiate a new MDF-e.',
    pu: 'Após o encerramento, será possível alterar informações ou emitir um novo MDF-e.'
  },
  ImportantTips: {
    zh: '重要提示',
    en: 'Important tips',
    pu: 'Importante'
  },
  PleaseConfirmThatItHasArrivedAtTheUnloadingState: {
    zh: '请确认当前已到达对应卸货州，并确保需要结束行程后再进行关闭操作。',
    en: 'Please confirm that you have arrived at the corresponding unloading state and that you need to close the trip before proceeding.',
    pu: 'Confirme que a carga já chegou ao estado de destino antes de realizar o encerramento.'
  },
  Cancel: {
    zh: '取消',
    en: 'Cancel',
    pu: 'Cancelar'
  },
  Confirm: {
    zh: '确认',
    en: 'Confirm',
    pu: 'Confirmar'
  },
  CancelMDFe: {
    zh: '取消 MDF-e（整单作废）',
    en: 'Cancel MDF-e (Cancel the entire order)',
    pu: 'Cancelar MDF-e (cancelamento definitivo)'
  },
  AreYouSureYouWantToCancelThisMDFe: {
    zh: '您确定要取消此 MDF-e 吗？',
    en: 'Are you sure you want to cancel this MDF-e?',
    pu: 'Tem certeza de que deseja cancelar este MDF-e?'
  },
  ThisOperationWillCancelTheEntireMDFe: {
    zh: '此操作将使整张 MDF-e 作废，且无法恢复。',
    en: 'This operation will cancel the entire MDF-e and cannot be recovered.',
    pu: 'Esta ação cancelará definitivamente o MDF-e e não poderá ser desfeita.'
  },
  ApplicableTime: {
    zh: '适用时间',
    en: 'Applicable time',
    pu: 'Prazo'
  },
  CanOnlyBeCancelled: {
    zh: '仅在 MDF-e 授权后 ',
    en: 'Can only be cancelled ',
    pu: 'Permitido apenas '
  },
  Within24Hours: {
    zh: '24小时内且尚未启运',
    en: 'Within 24 hours and before departure',
    pu: 'até 24h após a autorização e antes do início da viagem.'
  },
  Cancelable: {
    zh: '时可取消。',
    en: '',
    pu: ''
  },
  OnlyUsedForInputErrorsOrDuplicateSituations: {
    zh: '仅用于输入错误、重复等情况。',
    en: 'Only used for input errors or duplicate situations.',
    pu: 'Utilize apenas em casos de erro de preenchimento, duplicidade ou situações semelhantes.'
  },
  CannotBeCancelledOnceTheShipmentHasStarted: {
    zh: '运输已开始则禁止取消。',
    en: 'Cannot be cancelled once the shipment has started.',
    pu: 'Após o início da viagem, o cancelamento não é permitido.'
  },
  AfterCancellation: {
    zh: '取消成功后，MDF-e 状态将变更为',
    en: 'After cancellation, the MDF-e status will be changed to',
    pu: 'Após o cancelamento, o status do MDF-e será alterado para'
  },
  Canceled: {
    zh: '已取消',
    en: 'Canceled',
    pu: 'Cancelado'
  },
  CancellationCannotBeRecovered: {
    zh: '取消后将无法恢复，请确认后谨慎操作。',
    en: 'Cancellation cannot be recovered, please confirm carefully.',
    pu: 'Após o cancelamento, não será possível restaurar o MDF-e. Confirme antes de prosseguir.'
  },
  CancellationReason: {
    zh: '取消原因（非必填）',
    en: 'Cancellation reason (non-mandatory)',
    pu: 'Motivo do Cancelamento (Opcional)'
  },
  ToFacilitateSubsequentManagement: {
    zh: '为了便于后续管理，建议您填写取消原因。',
    en: 'To facilitate subsequent management, we recommend that you fill in the cancellation reason.',
    pu: 'Para facilitar o controle e a rastreabilidade, recomendamos informar o motivo do cancelamento.'
  },
  cteCount: {
    zh: 'CT-e数量',
    en: 'CT-e count',
    pu: 'Quantidade de CTe'
  },
  ExportByCustomer: {
    zh: '按客户导出',
    en: 'Export by customer',
    pu: 'Exportar por cliente'
  },
  selectExpectedDeliveryDate: {
    zh: '请选择理应送达时间',
    en: 'Please select the expected delivery time',
    pu: 'Por favor, selecione a data de entrega esperada'
  },
  selectDeliveryWeek: {
    zh: '请选择应交付周',
    en: 'Please select the delivery week',
    pu: 'Por favor, selecione a semana de entrega'
  },
  Airline: {
    zh: '航空公司',
    en: 'Airline',
    pu: 'Cia. Aérea'
  },
  ServiceCode: {
    zh: '服务代码',
    en: 'Service code',
    pu: 'Código de Serviço'
  },
  SenderName: {
    zh: '发货方名称',
    en: 'Sender name',
    pu: 'Nome do Remetente'
  },
  AddConfiguration: {
    zh: '新增配置',
    en: 'Add configuration',
    pu: 'Novo Configuração'
  },
  BasicConfiguration: {
    zh: '基础配置',
    en: 'Basic configuration',
    pu: 'Configuração Básica'
  },
  AirlineName: {
    zh: '航空公司名称',
    en: 'Airline name',
    pu: 'Nome da Companhia Aérea'
  },
  APIEnvironmentURL: {
    zh: 'API环境URL',
    en: 'API environment URL',
    pu: 'URL do Ambiente de API'
  },
  LoginEmail: {
    zh: '登录邮箱',
    en: 'Login email',
    pu: 'E-mail de Login'
  },
  LoginPassword: {
    zh: '登录密码',
    en: 'Login password',
    pu: 'Senha de Login'
  },
  TransportationParameters: {
    zh: '运输参数',
    en: 'Transportation parameters',
    pu: 'Parâmetros de Transporte'
  },
  TheSenderPaysTheShippingFeeAtTheOrigin: {
    zh: '发货方在起运地支付',
    en: 'The shipper pays at the place of departure',
    pu: 'Pagamento pelo remetente no local de partida'
  },
  TheReceiverPaysTheShippingFeeAtTheDestination: {
    zh: '收货方在目的地支付',
    en: 'The consignee pays at the destination',
    pu: 'Pagamento pelo destinatário na localidade de destino'
  },
  PayByCheckAccount: {
    zh: '通过支票账户支付',
    en: 'Pay by check account',
    pu: 'Pagamento por conta de cheque'
  },
  ReceiverPickupAtAirport: {
    zh: '收货人到机场自提',
    en: 'Receiver pickup at airport',
    pu: 'Retirada no Aeroporto'
  },
  DeliveryToDoor: {
    zh: '送货上门',
    en: 'Delivery to door',
    pu: 'Entrega em casa'
  },
  DeliveryType: {
    zh: '交付类型',
    en: 'Delivery type',
    pu: 'Tipo de Entrega'
  },
  GoodsNature: {
    zh: '货物性质',
    en: 'Goods nature',
    pu: 'Natureza dos Bens'
  },
  OperationCode: {
    zh: '操作代码',
    en: 'Operation code',
    pu: 'Código de Operação'
  },
  Normal: {
    zh: '正常',
    en: 'Normal',
    pu: 'Normal'
  },
  Fragile: {
    zh: '易碎',
    en: 'Fragile',
    pu: 'Fragil'
  },
  EasyToRot: {
    zh: '易腐',
    en: 'Easy to rot',
    pu: 'Fácil de desgastar'
  },
  IsItPickedUpInTheField: {
    zh: '是否现场取货',
    en: 'Is it picked up in the field',
    pu: 'Tem a retirada no local'
  },
  IdentifyTheAirlineToWhichTheConfigurationBelongs: {
    zh: '标识该配置归属的航空公司，便于多航司扩展时管理和区分。',
    en: 'Identify the airline to which the configuration belongs, which is convenient for managing and differentiating when multiple airlines extend.',
    pu: 'Identificar a companhia aérea a que a configuração pertence, para facilitar o gerenciamento e a distinção quando a extensão de múltiplas companhias aéreas.'
  },
  ProductionEnvironmentAPIBaseAddress: {
    zh: '生产环境的API基地址。当当前环境为生产环境时，系统向此地址发送请求。',
    en: 'Production environment API base address. When the current environment is production, the system sends requests to this address.',
    pu: 'URL base da API de produção. Quando o ambiente atual for de produção, o sistema enviará requisições para este endereço.'
  },
  AzulCargoProvidedAPIAuthenticationEmail: {
    zh: 'Azul Cargo提供的API认证邮箱，用于获取访问令牌Token。',
    en: 'Azul Cargo provided API authentication email, used to obtain access token.',
    pu: 'E-mail de autenticação da API fornecida pelo Azul Cargo, usado para obter o token de acesso.'
  },
  AuthenticationPasswordUsedWithEmail: {
    zh: '与邮箱配合使用的认证密码，系统将加密存储，不会明文显示。',
    en: 'Authentication password used with email, the system will encrypt storage, will not display in plain text.',
    pu: 'Senha de autenticação usada com o e-mail, o sistema irá criptografar o armazenamento, não será exibido em texto puro.'
  },
  DecideWhoPaysTheShippingFee: {
    zh: '决定运费由谁支付。PP-发货方在起运地支付，CC-收货方在目的地支付，PX-通过支票账户支付。',
    en: 'Decide who pays the shipping fee. PP-The sender pays at the origin, CC-The receiver pays at the destination, PX-Pay by check account.',
    pu: 'Decidir quem pagará a carga. PP-O remetente pagará no local de origem, CC-O destinatário pagará no local de destino, PX-Pagamento por conta de cheque.'
  },
  DeliveryMethodForGoodsCurrently: {
    zh: '货物交付方式。目前业务为机场自提，收货人到机场提取货物。',
    en: 'Delivery method for goods. Currently, the business is airport pickup, and the receiver picks up the goods at the airport.',
    pu: 'Método de entrega dos bens. Atualmente, o negócio é retirada no aeroporto, e o destinatário retira os bens no aeroporto.'
  },
  AzulCargoServiceLevelCode: {
    zh: 'Azul Cargo的服务等级代码，影响运输时效和计费。商务合同确定后由管理员选择，运营推送时自动引用。',
    en: 'Azul Cargo service level code, which affects the shipping time and billing. After the business contract is determined, the administrator selects it, and it is automatically referenced when the operation pushes.',
    pu: 'Códigos de nível de serviço da Azul Cargo que afetam o prazo de envio e a faturação. O contrato comercial é selecionado pelo administrador após a determinação e é referenciado automaticamente no push operacional.'
  },
  DescribeTheTypeOfGoodsBeingShipped: {
    zh: '描述运输货物的类别，如GERAL一般货物、ELETRONICOS电子产品等。Azul不接受通用描述，需按实际填写。',
    en: 'Describe the type of goods being shipped, such as GERAL general cargo, ELETRONICOS electronics, etc. Azul does not accept general descriptions, you need to fill in according to the actual situation.',
    pu: 'Descrição das categorias de mercadorias transportadas, como mercadorias gerais GERAL, eletrônicos ELETRONICOS, etc. A Azul não aceita descrições gerais, que devem ser preenchidas como realmente são.'
  },
  SpecialRequirementsForHandlingGoods: {
    zh: '货物处理特殊要求。若无特殊要求则选NOR正常。',
    en: 'Special requirements for handling goods. If there are no special requirements, select NOR normal.',
    pu: 'Requisitos especiais para o tratamento dos bens. Se não houver requisitos especiais, selecione NOR normal.'
  },
  IndicateWhetherAzulIsToPickUp: {
    zh: '指示Azul是否上门取货。当前业务为Anjun自行送货至机场，默认关闭。',
    en: 'Indicate whether Azul is to pick up. The current business is Anjun to deliver to the airport, the default is closed.',
    pu: 'Indicar se a Azul irá retirar. O negócio atual é Anjun entregar no aeroporto, o padrão é fechado.'
  },
  ThePasswordMustBeComposedOf8To16Characters: {
    zh: '密码必须包含字母、数字和特殊字符,且不少于8个字符',
    en: 'The password must contain letters, numbers, and special characters, and be no less than 8 characters',
    pu: 'A senha deve conter letras, números e caracteres especiais e ter no mínimo 8 caracteres'
  },
  AreYouSureToEnableThisAirlineConfiguration: {
    zh: '确认启用该航司配置？启用后将用于推送。',
    en: 'Are you sure to enable this airline configuration? It will be used for push.',
    pu: 'Tem certeza de que deseja ativar a configuração da companhia aérea? Ele será usado para push.'
  },
  AreYouSureToDisableThisAirlineConfiguration: {
    zh: '确认禁用该航司配置？禁用后将不可用于推送。',
    en: 'Are you sure to disable this airline configuration? It will not be used for push.',
    pu: 'Tem certeza de que deseja desativar a configuração da companhia aérea? Ele não será usado para push.'
  },
  AreYouSureToSaveAsADraft: {
    zh: '确定保存为暂存吗？暂存后配置将不可用于推送。',
    en: 'Are you sure to save as a draft? After saving, the configuration will not be used for push.',
    pu: 'Tem certeza de que deseja salvar como rascunho? Depois de salvar, a configuração não será usada para push.'
  },
  PendingPush: {
    zh: '待推送',
    en: 'Pending Push',
    pu: 'Pendente Push'
  },
  Pushed: {
    zh: '已推送',
    en: 'Pushed',
    pu: 'Pushed'
  },
  PushFailed: {
    zh: '推送失败',
    en: 'Push Failed',
    pu: 'Push Falhou'
  },
  AddPush: {
    zh: '新增推送',
    en: 'Add Push',
    pu: 'Novo Push'
  },
  Origin: {
    zh: '始发地',
    en: 'Origin',
    pu: 'Origem'
  },
  CTeQuantity: {
    zh: 'CTe数量',
    en: 'CTe quantity',
    pu: 'Qtd. CTe'
  },
  Pusher: {
    zh: '推送人',
    en: 'Pusher',
    pu: 'Pusher'
  },
  PushTime: {
    zh: '推送时间',
    en: 'Push Time',
    pu: 'Tempo de Push'
  },
  AviationPush: {
    zh: '航空推送',
    en: 'Aviation Push',
    pu: 'Push Aéreo'
  },
  RePush: {
    zh: '重新推送',
    en: 'Re-push',
    pu: 'Reenviar'
  },
  PleaseEnterA44DigitKey: {
    zh: '请输入44位秘钥',
    en: 'Please enter a 44-digit key',
    pu: 'Por favor, insira uma chave de 44 dígitos'
  },
  BatchImport: {
    zh: '批量导入',
    en: 'Batch import',
    pu: 'Importar Push em Lote'
  },
  AWBNumber: {
    zh: 'AWB号',
    en: 'AWB number',
    pu: 'Nº AWB'
  },
  PleaseEnterMDFeKey: {
    zh: '请输入MDFe密钥，每行一个，最多100个。',
    en: 'Please enter MDFe key, one per line, up to 100.',
    pu: 'Por favor, insira a chave MDFe, uma por linha, até 100.'
  },
  LoadDraft: {
    zh: '载入草稿',
    en: 'Load draft',
    pu: 'Carregar rascunho'
  },
  NoDraftAvailable: {
    zh: '暂无草稿',
    en: 'No draft available',
    pu: 'Sem rascunho'
  },
  PleaseEnterTheCorrectCNPJ: {
    zh: '请输入正确的CNPJ',
    en: 'Please enter the correct CNPJ',
    pu: 'Informe um CNPJ válido'
  },
  PushDetails: {
    zh: '推送详情',
    en: 'Push Details',
    pu: 'Detalhes do Push'
  },
  TheStatusOfMdfeHasBeenChangedTo: {
    zh: 'MDFe状态已变更为',
    en: 'The status of MDFe has been changed to',
    pu: 'Status do MDFe alterado para'
  },
  PleaseFollow: {
    zh: '请关注',
    en: 'Please follow',
    pu: 'verifique'
  },
  CurrentStatusMDFe: {
    zh: 'MDFe 当前状态',
    en: 'Current status of MDFe',
    pu: 'Status MDFe'
  },
  TargetAirline: {
    zh: '目标航司',
    en: 'Target Airline',
    pu: 'Cia. Destino'
  },
  DepartureAirportCode: {
    zh: '始发地机场代码',
    en: 'Departure airport code',
    pu: 'Aeroporto Origem'
  },
  NumberOfAssociatedCTe: {
    zh: '关联CTe数量',
    en: 'Number of Associated CTe',
    pu: 'Qtd. CTe'
  },
  DestinationAirportCode: {
    zh: '目的地机场代码',
    en: 'Destination airport code',
    pu: 'Aeroporto Destino'
  },
  TotalQuantity: {
    zh: '总件数',
    en: 'Total Quantity',
    pu: 'Volumes'
  },
  PrototypeDemonstration: {
    zh: '原型演示：选择推送结果场景',
    en: 'Prototype demonstration: Select push result scenario',
    pu: 'Demo: Selecione o cenário'
  },
  departureAirport: {
    zh: '始发地机场',
    en: 'departure airport',
    pu: 'Aeroporto de origem'
  },
  DestinationState: {
    zh: '目的地州',
    en: 'Destination State',
    pu: 'Estado de destino'
  },
  StateOfOrigin: {
    zh: '始发地州',
    en: 'State of Origin',
    pu: 'Estado de origem'
  },
  PleaseSelectStateFirst: {
    zh: '请先选择州',
    en: 'Please select state first',
    pu: 'Por favor, selecione o estado primeiro'
  },
  PushOrderNumber: {
    zh: '推送订单号',
    en: 'Push Order Number',
    pu: 'Enviar número do pedido'
  },
  TotalValueOfGoods: {
    zh: '货物总价值',
    en: 'Total value of goods',
    pu: 'Valor total da mercadoria'
  },
  ConfirmPush: {
    zh: '确认推送',
    en: 'Confirm Push',
    pu: 'Confirmar envio'
  },
  PleaseConfirmWhetherToPushTheCTeDataTo: {
    zh: '请确认是否将CTe数据推送至',
    en: 'Please confirm whether to push the CTe data to',
    pu: 'Confirmar envio dos dados CTe para'
  },
  ProductCode: {
    zh: '产品代码',
    en: 'Product Code',
    pu: 'Código do produto'
  },
  ItCanBeUsedForEnteringProductCodeTypes: {
    zh: '可用于输入产品代码类型。',
    en: 'It can be used for entering product code types.',
    pu: 'Pode ser utilizado para o tipo de código de produto de entrada'
  },
  CancelPush: {
    zh: '取消推送',
    en: 'Cancel push',
    pu: 'Cancelar notificações'
  },
  wantToCancelThePush: {
    zh: '确定要取消推送',
    en: 'Are you sure you want to cancel the push',
    pu: 'Tem certeza que deseja cancelar o push'
  },
  destinationAirport: {
    zh: '目的地机场',
    en: 'destination airport',
    pu: 'Aeroporto de destino'
  },
  StatusBeforeOperation: {
    zh: '操作前状态',
    en: 'Status before operation',
    pu: 'Estado antes da operação'
  },
  PostOperationStatus: {
    zh: '操作后状态',
    en: 'Post-operation status',
    pu: 'Estado após a operação'
  },
  BatchOperationID: {
    zh: '批量操作ID',
    en: 'Batch Operation ID',
    pu: 'ID de operação em lote'
  },
  AssociatedCTEKey: {
    zh: '关联CTE密钥',
    en: 'Associated CTE key',
    pu: 'Chave CTE associada'
  },
  OperationSource: {
    zh: '操作来源',
    en: 'Operation source',
    pu: 'Origem da operação'
  },
  ValueSupplement: {
    zh: '价值补充',
    en: 'Value Supplement',
    pu: 'Complemento de valor'
  },
  revoke: {
    zh: '撤销',
    en: 'revoke',
    pu: 'Anular'
  },
  substitute: {
    zh: '替代',
    en: 'substitute',
    pu: 'substitute'
  }
};
export { mdfeTranslate };
